export const discoverWinnerBalls = (chosen, result) => {
  return chosen.map((element) => {
    if (result.includes(element)) {
      return { number: +element, won: true };
    } else {
      return { number: +element, won: false };
    }
  });
};

export const winnerBallObjects = (result) => {
  return result.map((element) => {
    return { number: +element, won: false };
  });
};
